<template>
  <transition name="fade" mode="out-in">
    <router-view></router-view>
  </transition>
</template>

<script>
  import {appName, api, countrieList} from "../../config";
  import {mapState} from 'vuex';
  import {mapGetters} from 'vuex';
  
  export default {
    name: 'NoticeWrapper',
    methods: {
    }
  }
</script>
<style>
  .news-head{
    font-weight: bold;
    font-size: 23px;
    line-height: 41px;
    border-bottom: 1px solid #eeeeee;
    padding: 15px;
    color: #686868;
  }
</style>
